<template>
    <KtvCard
        :description="$t('ktvThen.ktvEditMessage.description')"
        icon="check-circle"
        :is-complete="isMessageValid"
        :show-error="showError"
        :title="$t('ktvThen.ktvEditMessage.title')"
    >
        <template #content>
            <SmsTextBox
                v-model="messageContent"
                :has-error="showError && !isMessageValid"
                :ktv-enabled="true"
                :content-editable="contentEditable"
                @input="handleUpdate"
            />
        </template>
    </KtvCard>
</template>

<script>
import KtvCard from './KtvCard.vue';
import { SMS_MESSAGE_LENGTH } from '@/components/broadcast/constants/smsBroadcast.constants';
import { containsSupportedCharacters } from '@/components/automatedSms/automatedSms.util';
import SmsTextBox from '@/components/automatedSms/SmsTextBox.vue';

export default {
    components: { SmsTextBox, KtvCard },

    props: {
        message: {
            type: String,
            default: '',
        },
        contentEditable: {
            type: Boolean,
            default: true,
        },
        showError: Boolean,
    },

    emits: ['message-updated'],

    data() {
        return {
            messageContent: this.message || '',
        };
    },

    computed: {
        isMessageTooLong() {
            return this.messageContent?.length > SMS_MESSAGE_LENGTH.MAXIMUM;
        },

        isMessageValid() {
            return !!this.messageContent?.length && !this.isMessageTooLong && this.messageContainsValidCharacters;
        },

        messageContainsValidCharacters() {
            return containsSupportedCharacters(this.messageContent);
        },
    },

    watch: {
        message: {
            handler(value) {
                this.messageContent = value;
            },
            immediate: true,
            deep: true,
        },
    },

    methods: {
        handleUpdate(message) {
            this.messageContent = message;

            if (this.messageContainsValidCharacters) {
                this.$emit('message-updated', message);
            }
        },
    },
};

</script>

<style lang="scss" scoped>
.ktv-edit-message {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-100);
}
</style>
